module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-dusty-rose-2-4a66b604eac91b4355bdb4aa18265804.png";